import clsx from "clsx";

import * as css from "./AsdieFilterContainer.css";

type Props = {
  className?: string;
  children: React.ReactNode;
};

export function AsideFilterContainer({ className, children }: Props) {
  return <aside className={clsx(className, css.aside)}>{children}</aside>;
}
